/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Export_LogInputs */

const cs_sreality_export_log = /** @type {(inputs: Sreality_Export_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log exportu`)
};

const en_sreality_export_log = /** @type {(inputs: Sreality_Export_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export log`)
};

/**
* | output |
* | --- |
* | "Export log" |
*
* @param {Sreality_Export_LogInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_export_log = /** @type {((inputs?: Sreality_Export_LogInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Export_LogInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_export_log(inputs)
	return cs_sreality_export_log(inputs)
});